import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Modal, Button, Alert } from 'react-bootstrap';
import { VerticalForm } from '../../components';
import { TextArea, TextInput } from '../../components/FormComponents';
import PageTitle from '../../components/PageTitle'
import Popup from '../../components/Popup';
import Table from '../../components/Table';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FeatherIcon from 'feather-icons-react';

const API = process.env.REACT_APP_CLIENT_IP;

function PackageType() {

    const [show, setShow] = useState(false);
    const [data, setData] = useState([]);
    const [inputData, setInputData] = useState({})
    const [validated, setValidated] = useState({ progress: false, login: false });
    const [notify, setNotify] = useState({ show: false, variant: '', message: '' })
    const [showPop, setShowPop] = useState({ show: false, dataId: '' });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const columns = [
        {
            Header: 'Package Type',
            accessor: 'productTypeName',
            sort: true,
        },
        {
            Header: 'Description',
            accessor: 'description',
            sort: true,
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: (cell) => {
                let { original } = cell.cell.row;
                return <div style={{ display: 'flex', flexDirection: 'row', border: 'none', alignItems: 'center' }}>
                    <FeatherIcon onClick={() => {
                        setShow(true); setInputData(original); setValidated({});
                    }} style={{ cursor: 'pointer' }} className="icon-dual-info" icon="edit-2" />
                    <FeatherIcon onClick={() => {
                        setShowPop({ show: true }); setInputData(original)
                    }} style={{ marginLeft: '3px', cursor: 'pointer' }} className="icon-dual-danger" icon="trash-2" />
                </div>
            }
        }
    ];

    const sizePerPageList = [
        {
            text: '5',
            value: 5,
        },
        {
            text: '10',
            value: 10,
        },
        {
            text: '25',
            value: 25,
        },
        {
            text: 'All',
            value: data.length,
        },
    ];

    const schema = yup.object().shape({
        productTypeName: yup.string().required("product Type is required!"),
    })

    const schemaResolver = yupResolver(schema);

    const handleChange = (event) => {
        const { name, value } = event.target
        setInputData({
            ...inputData, [name]: value
        })
        if (name === 'productTypeName' && value !== '') {
            setValidated({ ...validated, [name]: false });
        } else { setValidated({ ...validated, [name]: true }); }
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            let isValid = schema.validateSync(inputData)
            if (isValid) {
                if (inputData.productTypeId === 0 || inputData.productTypeId === undefined) {
                    inputData.productTypeId = undefined;
                    const data = JSON.stringify(inputData);
                    try {
                        let res = await fetch(`${API}/api/producttype/create`, {
                            method: 'POST',
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: data
                        }).then(response => response.json());
                        if (res.success) {
                            setNotify({ show: true, variant: 'success', message: 'Saved Successfully!' })
                            setInputData({})
                            fetchRecords();
                            handleClose();
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        } else {
                            setNotify({ show: true, variant: 'warning', message: res.error ? res.error.msg : "Something went wrong" })
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    const data = JSON.stringify(inputData);
                    try {
                        let res = await fetch(`${API}/api/producttype/${inputData.productTypeId}`, {
                            method: 'PUT',
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: data
                        }).then(response => response.json());
                        if (res.success) {
                            setNotify({ show: true, variant: 'success', message: 'Updated Successfully!' })
                            setInputData({})
                            fetchRecords();
                            handleClose();
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        } else {
                            setNotify({ show: true, variant: 'warning', message: res.error ? res.error.msg : "Something went wrong" });
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
        } catch (error) {
            error && setValidated({productTypeName: true});
        }
    };

    const fetchRecords = async () => {
        let res = await fetch(`${API}/api/producttype/list`).then(response => response.json());
        if (res.success) {
            setData(res.data);
            console.log(res.data);
        }
    }

    const onDelete = async (id) => {
        try {
            let res = await fetch(`${API}/api/producttype/${id}`, {
                method: 'DELETE'
            }).then(response => response.json());
            if (res.success) {
                fetchRecords();
                setInputData({});
                setShowPop({ show: false, dataId: '' })
                setNotify({
                    show: true,
                    message: "Deleted Successfully!",
                    variant: "success",
                });
                setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
            } else {
                setNotify({
                    show: true,
                    message: `${res.data.error.msg}`,
                    variant: "danger",
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {fetchRecords();}, [])
    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: 'Home', path: '/packagetype' },
                    { label: 'Package/Product Types', path: '/packagetype', active: true },
                ]}
                title={'Package/Product Types'}
            />

            <Popup show={showPop.show}
                handleClose={() => setShowPop({ show: false })}
                handleDelete={() => onDelete(inputData.productTypeId)}
            />
            <Alert show={notify.show} variant={notify.variant} >{notify.message}</Alert>

            <Modal show={show} size='lg' centered>
                <Modal.Header onHide={handleClose} closeButton>
                    <p className="text-muted fs-14">
                        Fill in the Package Type details
                    </p>
                </Modal.Header>

                <Row>
                    <Col>
                        <Card>
                            <Card.Body>

                                <VerticalForm resolver={schemaResolver} onSubmit={handleSubmit}>
                                    <Row>
                                    <TextInput
                                        textTitle={'Package Type Name'}
                                        textName='productTypeName'
                                        onChange={handleChange}
                                        required={!inputData.productTypeName && validated.productTypeName}
                                        value={inputData.productTypeName}
                                    />
                                    </Row>

                                    <Row>
                                    <TextArea
                                        AreaTitle={'Description'}
                                        areaName='description'
                                        onChange={handleChange}
                                        value={inputData.description}
                                    />
                                    </Row>
                                    <Button style={{ float: 'right' }} variant="primary" type="submit" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </VerticalForm>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Modal>

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col xs={8}>
                                    <h4 className="header-title">Package/Product Types</h4>
                                    <p className="text-muted fs-14 mb-4">List of Packages/Products</p>
                                </Col>
                                <Col xs={4}>
                                    <Button style={{ float: 'right' }} variant="success"
                                        type="submit" className="btn-sm" onClick={handleShow}>
                                        Add New
                                        <i className='bi-plus-lg' style={{ marginLeft: '5px', fontSize: '' }}></i>
                                    </Button>
                                </Col>
                            </Row>

                            <Table
                                columns={columns}
                                data={data}
                                pageSize={5}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                isSearchable={true}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default PackageType